import React from "react";
import { ReceiptText } from "lucide-react";
import HRISListPage from "../../../HRISListPage";
import {
  getHRExpenses,
  createHRExpense,
  updateHRExpense,
  deleteHRExpense,
  getEmployeeList,
  getExpenseClaimTypes,
} from "../../../hrisApi";

import "../../../hrisDummyData"; // Auto-initializes dummy data on load

const STATUS_OPTIONS = [
  "Draft",
  "Submitted",
  "Approved",
  "Rejected",
  "Cancelled",
];

const columns = [
  { key: "employeeName", label: "Employee" },
  { key: "expenseDate", label: "Date" },
  { key: "expenseType", label: "Type" },
  {
    key: "totalClaimed",
    label: "Total Claimed",
    render: (v) => (v ? `Rp ${Number(v).toLocaleString("id-ID")}` : "—"),
  },
  {
    key: "totalSanctioned",
    label: "Sanctioned",
    render: (v) => (v ? `Rp ${Number(v).toLocaleString("id-ID")}` : "—"),
  },
  { key: "company", label: "Company" },
  { key: "status", label: "Status", badge: true },
];

const formFields = [
  {
    key: "employeeId",
    label: "Employee ID",
    type: "text",
    required: true,
    placeholder: "e.g. EMP-001",
  },
  {
    key: "employeeName",
    label: "Employee",
    type: "select",
    required: true,
    optionsLoader: getEmployeeList,
  },
  { key: "expenseDate", label: "Expense Date", type: "date", required: true },
  {
    key: "expenseType",
    label: "Expense Claim Type",
    type: "select",
    required: true,
    optionsLoader: getExpenseClaimTypes,
    placeholder: "Select a claim type",
  },
  {
    key: "totalClaimed",
    label: "Total Claimed (Rp)",
    type: "currency",
    required: true,
    placeholder: "0",
  },
  {
    key: "company",
    label: "Company",
    type: "text",
    placeholder: "Company name",
  },
  {
    key: "status",
    label: "Status",
    type: "select",
    options: STATUS_OPTIONS,
    defaultValue: "Draft",
  },
  {
    key: "description",
    label: "Description",
    type: "textarea",
    placeholder: "Expense details...",
  },
];

const Expenses = () => (
  <HRISListPage
    title="Expense Claims"
    description="Manage employee expense claims and reimbursements."
    icon={<ReceiptText />}
    columns={columns}
    fetchData={getHRExpenses}
    createData={createHRExpense}
    updateData={updateHRExpense}
    deleteData={deleteHRExpense}
    formFields={formFields}
    entityName="Expense Claim"
    searchPlaceholder="Search by employee or type..."
  />
);

export default Expenses;
